import React, {useState,  useEffect, useRef} from "react";
import { useHistory } from "react-router-dom";
import sidebarRoutes from "../../routes/sidebarRoutes";
import { Search } from "lucide-react";
import searchIcon from "../../assets/images/searchIcon.svg"
import "./QuickFindSearchbar.css";

const QuickFindSearchbar = ({ placeholder = "Quick Find", onChange }) => {

  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const history = useHistory();
  const searchbarRef = useRef(); 

  useEffect(() =>{
    const handleClickOutside = (event) => {
      if (searchbarRef.current && !searchbarRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [])

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if(value === ''){
      setSuggestions([]);
      return;
    }
    const routes = sidebarRoutes.filter((match) => match.label.toLowerCase().includes(value.toLowerCase()));
    setSuggestions(routes);

  }

  const handelKeyDown = (e) => {
    if(e.key === 'Enter' && suggestions.length > 0){
      history.push(suggestions[0].path)
      setSuggestions([]);
      setQuery('');
    }
  }

  const handleSuggestionClick = (path) => {
    history.push(path);
    setSuggestions([]);
    setQuery('');
  };

  return (
    <div className="quick-find-container" ref={searchbarRef}>
    <div className="quick-find-searchbar">
        <Search size={20}/>
      <input
        type="text"
        className="quick-find-search-input"
        placeholder={placeholder}
        value={query}
        onChange={handleChange}
        onKeyDown={handelKeyDown}
      />
    </div>
     {suggestions.length > 0 && (
       <ul className="custom-search-suggestions">
          {suggestions.map((route, index) => (
            <li
            key={index}
            className="suggestion-item"
            onClick={() => handleSuggestionClick(route.path)}
            >
              {route.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default QuickFindSearchbar;
